import React from 'react';
import { VendorChangeRequestEntity } from '../../models';
import { ChangeRequestContextType } from '../../types';

type VendorChangeRequestContextType = ChangeRequestContextType<VendorChangeRequestEntity>;

export const VendorChangeRequestContext = React.createContext<VendorChangeRequestContextType>(
  {} as VendorChangeRequestContextType,
);
